import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";



@Component({
  selector: 'transferSummaryDialog',
  templateUrl: 'transferSummaryDialog.html',
  styleUrls: ['./transferSummaryDialog.css']
})
export class TransferSummaryDialog extends DialogBase {
  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super("transferSummaryDialog");
  }

  public confirm() {
    this.dialogRef.close(true)
  }

  public close() {
    this.dialogRef.close();
  }
}
